export default function app_busca_evento(state = {}, action) {
  switch(action.type) {
    case 'add_app_busca_evento': 
      state = action.json;
      return state;
    default: 
      return state; 
  }
}